<template>
  <div>
    <!-- 专题卡片表单 -->
    <div class="form-container">
      <el-form class="subjectForm" :model="subjectForm" :rules="rules" ref="subjectForm" label-width="100px">
        <el-form-item label="卡片名称" prop="name">
          <el-input maxlength="99" size="small" v-model="subjectForm.name" placeholder="请输入卡片名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="卡片标题" prop="title">
          <el-input maxlength="99" size="small" v-model="subjectForm.title" placeholder="请输入卡片标题" clearable></el-input>
        </el-form-item>
        <el-form-item label="卡片描述" prop="description">
          <el-input maxlength="99" size="small" v-model="subjectForm.description" placeholder="请输入卡片描述"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="coverImg">
          <el-upload class="avatar-uploader" :before-upload="fileCheck" :http-request="upload" :show-file-list="false">
            <el-image v-if="subjectForm.coverImg" :src="subjectForm.coverImg" fit="scale-down" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="图片宽度尺寸">
          <el-radio-group v-model="subjectForm.imgSelectWidth">
            <el-radio label="300">小图：300px (推荐)</el-radio>
            <el-radio label="700">大图：700px (推荐)</el-radio>
            <el-radio :label="-1">自定义图片宽度</el-radio>
          </el-radio-group>
          <el-popover placement="top" width="200" trigger="hover" content="如果输入了自定义图片宽度，以自定义图片宽度为准">
            <i class="el-icon-question" slot="reference" style="margin-left: 40px;color: #507dc5;"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label=" " v-if="subjectForm.imgSelectWidth === -1">
          <el-input size="small" v-model="subjectForm.imgWidth" placeholder="请输入图片宽度(单位px)" clearable></el-input>
        </el-form-item>
        <el-form-item label="内容列表" prop="items">
          <el-button size="small" @click="selectAppCards">选择</el-button>
          <avue-crud v-if="subjectForm.items.length" style="width: 100%" :option="option" :data="subjectForm.items"
            ref="crud">
            <!-- 自定义搜索框 -->
            <template slot="mySearch"> </template>
            <!-- 自定义表格列 -->
            <template #coverImg="{ row }">
              <el-image v-if="row.coverImg" style="width: 100px; height: 100px" :src="row.coverImg"
                fit="scale-down"></el-image>
              <span v-else>暂无图片</span>
            </template>
            <template #operation="{ row }">
              <el-button 
                type="text" 
                :disabled="!canMoveUp(subjectForm.items, row)" 
                @click="moveUp(row)"
              >
                上移
              </el-button>
              <el-button 
                type="text" 
                :disabled="!canMoveDown(subjectForm.items, row)" 
                @click="moveDown(row)"
              >
                下移
              </el-button>
              <el-button 
                type="text" 
                :disabled="!canMoveTop(subjectForm.items, row)" 
                @click="moveTop(row)"
              >
                置顶
              </el-button>
              <el-button type="text" style="color: #f56c6c;" @click="remove(row)">移除</el-button>
            </template>
          </avue-crud>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input maxlength="9999" show-word-limit size="small" type="textarea" v-model="subjectForm.remark"
            placeholder="请输入备注" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="subjectForm.status">
            <el-radio :label="1">生效</el-radio>
            <el-radio :label="0">失效</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 生效模式 -->
        <el-form-item v-if="subjectForm.status === 1" label="选择" prop="effectMode">
          <!-- 立即生效 1  指定时间生效 2 -->
          <el-radio-group v-model="subjectForm.effectMode">
            <el-radio :label="1">立即生效</el-radio>
            <el-radio :label="2">指定时间生效</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 生效时间 -->
        <el-form-item v-if="subjectForm.status === 1 && subjectForm.effectMode === 2" label="生效时间" prop="effectTime">
          <el-date-picker size="small" :picker-options="{
            disabledDate(time) {
              return time.getTime() < Date.now() - 8.64e7;
            },
          }" v-model="subjectForm.effectTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
            range-separator="至" start-placeholder="生效开始时间" end-placeholder="生效结束时间" clearable>
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <!-- 保存和取消 -->
    <div class="btn-container" style="text-align: right; margin-top: 20px">
      <el-button size="small" type="primary" @click="save">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
    <MultipleCards ref="multipleCards" @save="getContentList"></MultipleCards>
  </div>
</template>

<script>
import MultipleCards from "./multipleCards.vue";
import Message from "@/components/Message";
import axios from "axios";
import { formatAddSubject, validateImageWidth, updateImgUrl } from "../utils/helper";
import { addAppCard, updateAppCard } from "@/api/apps/appCard";
// eslint-disable-next-line no-unused-vars
import { moveUp, moveDown, moveTop, removeItem, canMoveUp, canMoveDown, canMoveTop } from "../utils/sortUtils";
import _ from 'lodash'

export default {
  name: "WebSaaSSubjectForm",
  components: {
    MultipleCards,
  },
  inject: ["optionType"],
  data() {
    return {
      subjectForm: {
        /** 卡片名称 */
        name: "",
        /** 卡片标题 */
        title: "",
        /** 卡片描述 */
        description: "",
        /** 图片 */
        coverImg: "",
        /** 图片宽度 */
        imgWidth: "",
        /** 图片选择宽度 */
        imgSelectWidth: '300',
        /** 内容列表 */
        items: [],
        /** 备注 */
        remark: "",
        /** 状态 （1：生效；0：失效）*/
        status: "",
        /** 卡片类型 1：焦点卡片；2：专题卡片；3：导航卡片 */
        type: 2,
        /** 生效模式 1：立即生效；2：指定时间生效 */
        effectMode: "",
        /** 生效时间 */
        effectTime: [],
      },
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: false,
        // searchMenuSpan: 6,
        tree: true,
        border: true,
        /** 表格索引 */
        index: false,
        /** 索引说明 */
        indexLabel: "No",
        /** 表格搜索显隐按钮 */
        searchShowBtn: false,
        /** 是否启用功能按钮 */
        searchIcon: false,
        searchIndex: 0,
        /** 表格查看按钮 */
        viewBtn: false,
        /** 表格新增按钮 */
        addBtn: false,
        /** 表格删除按钮 */
        delBtn: false,
        /** 表格修改按钮 */
        editBtn: false,
        /** 表格搜索按钮 */
        searchBtn: false,
        /** 表格清空按钮 */
        emptyBtn: false,
        /** 表格列操作按钮 */
        columnBtn: false,
        /** 表格刷新数据按钮 */
        refreshBtn: false,
        /** 开启拖拽功能 */
        sortable: true,
        // dragHandler: true,
        rowSort: true,
        columnSort: true,
        menu: false,
        menuWidth: 120,
        // menuFixed: true,
        column: [
          {
            label: "ID",
            prop: "id",
            width: 40,
          },
          {
            label: "内容标题",
            prop: "title",
            overHidden: true,
          },
          {
            label: "内容图片",
            prop: "coverImg",
            slot: true,
            width: 140,
          },
          {
            label: "显示顺序",
            prop: "displayOrder",
          },
          {
            label: "热度值",
            prop: "hotScore",
          },
          {
            label: "宣传标签",
            prop: "tags",
            overHidden: true,
          },
          {
            label: "描述",
            prop: "description",
            overHidden: true,
          },
          {
            label: "状态",
            prop: "status",
            dicData: [
              {
                label: "上架",
                value: 1,
              },
              {
                label: "下架",
                value: 0,
              },
            ],
          },
          {
            label: "操作",
            prop: "operation",
            width: 200,
            slot: true,
          },
          {
            label: "",
            prop: "my",
            hide: true,
            showColumn: false,
            search: true,
            display: false,
            menuClassName: "myClass",
            searchslot: true,
          },
        ],
      },
      /** 表单验证规则 */
      rules: {
        /** 卡片名称 */
        name: [
          {
            required: true,
            message: "请输入卡片名称",
            trigger: "blur",
          },
        ],
        /** 卡片标题 */
        title: [
          {
            required: false,
            message: "请输入卡片标题",
            trigger: "blur",
          },
        ],
        /** 卡片描述 */
        description: [
          {
            required: false,
            message: "请输入卡片描述",
            trigger: "blur",
          },
        ],
        /** 图片 */
        coverImg: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
        /** 内容列表 */
        items: [
          {
            required: true,
            message: "请选择内容列表",
            trigger: "change",
          },
          {
            type: "array",
            min: 1,
            message: "请至少选择一个内容列表",
            trigger: "change",
          },
        ],
        /** 备注 */
        remark: [
          {
            required: false,
            message: "请输入备注",
            trigger: "blur",
          },
        ],
        /** 状态 （1：生效；0：失效）*/
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "blur",
          },
        ],
        /** 生效模式 1：立即生效；2：指定时间生效 */
        effectMode: [
          {
            required: true,
            message: "请选择生效模式",
            trigger: "blur",
          },
        ],
        /** 生效时间 */
        effectTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log("生效时间", value);
              if (value === undefined || value.length === 0) {
                callback(new Error("请选择生效时间"));
              } else {
                // 校验开始时间，大于当前时间
                if (value[0]) {
                  // 将字符串格式的开始时间转换为Date对象
                  const startTime = new Date(value[0]);

                  // 检查转换是否成功，且开始时间是否大于当前时间
                  if (
                    isNaN(startTime.getTime()) ||
                    startTime.getTime() < Date.now()
                  ) {
                    callback(new Error("生效开始时间不能小于当前时间"));
                  }
                }
                if (value[1]) {
                  // 将字符串格式的结束时间转换为Date对象
                  const endTime = new Date(value[1]);

                  // 检查转换是否成功，且结束时间是否大于开始时间
                  if (
                    isNaN(endTime.getTime()) ||
                    endTime.getTime() < new Date(value[0]).getTime()
                  ) {
                    callback(new Error("生效结束时间不能小于开始时间"));
                  }
                }
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    /** 编辑的方法 */
    async edit(form) {
      const params = formatAddSubject(form);
      console.log("编辑专题卡片的参数", params);
      const { data } = await updateAppCard(params);
      console.log("编辑专题卡片的响应", data);
      if (data.code === 200) {
        Message.success("编辑成功");
        // debugger
        this.$emit("reload");
        this.$emit("close");
      }
    },
    /** 新增的方法 */
    async add(form) {
      const params = formatAddSubject(form);
      console.log("新增专题卡片的参数", params);
      const { data } = await addAppCard(params);
      console.log("新增专题卡片的响应", data);
      if (data.code === 200) {
        Message.success("新增成功");
        this.$emit("close");
        this.$emit("reload");
      }
    },
    /** 重置表单值 */
    reset() {
      /** 清空表单 */
      this.subjectForm = {
        /** 卡片名称 */
        name: "",
        /** 卡片标题 */
        title: "",
        /** 卡片描述 */
        description: "",
        /** 图片 */
        coverImg: "",
        /** 图片宽度 */
        imgWidth: "",
        /** 图片选择宽度 */
        imgSelectWidth: '300',
        /** 内容列表 */
        items: [],
        /** 备注 */
        remark: "",
        /** 状态 */
        status: "",
        /** 卡片类型 1：焦点卡片；2：专题卡片；3：导航卡片 */
        type: 2,
        /** 生效模式 1：立即生效；2：指定时间生效 */
        effectMode: "",
        /** 生效时间 */
        effectTime: [],
      };
      /** 清空表单验证规则 */
      this.$refs.subjectForm.clearValidate();
    },
    /** 关闭的事件 */
    cancel() {
      this.$emit("close");
      /** 清空表单验证规则 */
      this.$refs.subjectForm.clearValidate();
    },
    /** 保存的事件 */
    save() {
      this.$refs.subjectForm.validate(async (valid) => {
        if (valid) {
          console.log("subjectForm", this.subjectForm);
          /** 保存 */
          console.log("专题卡片验证通过");

          /** 校验图片宽度 */
          if (!validateImageWidth(this.subjectForm)) {
            return;
          }
          /** merge 对象防止响应式丢失 */
          _.merge(this.subjectForm, updateImgUrl(this.subjectForm))

          if (this.optionType.value === "add") {
            this.add(this.subjectForm);
          } else {
            this.edit(this.subjectForm);
          }
        } else {
          console.log("专题卡片验证失败");
          return false;
        }
      });
    },
    /** 上传图片校验 */
    fileCheck(file) {
      // 判断类型
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        Message.error("目前只支持jpg/png图片");
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 2) {
        Message.error("不能上传超过2M的图片");
        return false;
      }
    },
    /** 上传图片的方法 */
    async upload(params) {
      const file = params.file;
      let navForm = new FormData();
      navForm.append("file", file);
      try {
        const { data } = await axios.post(
          "/lebo-resource/oss/endpoint/put-file?code=lebotob",
          navForm,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("上传图片的响应", data);
        const result = data.data;
        if (data.code === 200) {
          /** 上传成功 */
          /** 赋值 */
          this.subjectForm.coverImg = result.link;
          /** 提示用户 */
          Message.success("上传成功");
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    /** 选择内容列表 */
    selectAppCards() {
      console.log("选择内容列表", this.subjectForm.items);
      this.$refs.multipleCards.show([...this.subjectForm.items]);
    },
    /** 接收选择内容列表 */
    getContentList(list) {
      console.log("getContentList", list);
      this.subjectForm.items = list;
    },
    /** 上移 */
    moveUp(row) {
      moveUp(this.subjectForm.items, row);
    },
    /** 下移 */
    moveDown(row) {
      moveDown(this.subjectForm.items, row);
    },
    /** 置顶 */
    moveTop(row) {
      moveTop(this.subjectForm.items, row);
    },
    /** 移除 */
    remove(row) {
      removeItem(this.subjectForm.items, row);
    },
    /** 是否可以上移 */
    canMoveUp(items, row) {
      return canMoveUp(items, row);
    },
    /** 是否可以下移 */
    canMoveDown(items, row) {
      return canMoveDown(items, row);
    },
    /** 是否可以置顶 */
    canMoveTop(items, row) {
      return canMoveTop(items, row);
    },
  },
};
</script>

<style lang="scss" scoped>
.subjectForm {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  ::v-deep .avatar-uploader .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    background-color: #f5f7fa;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  // ::v-deep .el-input__inner {
  //   width: 250px !important;
  // }
  ::v-deep .el-textarea__inner {
    min-height: 70px !important;
  }
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

//^ ^--------------avue-crud的样式-------------^ ^
::v-deep .avue-crud__menu {
  display: none;
}

::v-deep .avue-crud .el-card {
  padding: 0 !important;
  overflow: auto !important;
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep .avue-crud .avue-crud__search .avue-form .avue-form__group .avue-form__row .el-form-item label {
  float: none;
  display: inline-block;
}

::v-deep .avue-crud__pagination {
  display: none !important;
}
</style>